/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_NotInputs */

const en_filter_not = /** @type {(inputs: Filter_NotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not`)
};

const de_filter_not = /** @type {(inputs: Filter_NotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nicht`)
};

/**
* | output |
* | --- |
* | "not" |
*
* @param {Filter_NotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_not = /** @type {((inputs?: Filter_NotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_NotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_not(inputs)
	return en_filter_not(inputs)
});